/**
 *
 * @module configurationHostName
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef ConfigurationHostName
 * @type {Object}
 *
 * @property {String} dev
 * @property {String} prod
 *
 */

/**
 *
 * @enum
 * @type {ConfigurationHostName}
 * @desc Enum for the possible host name values in the ConfigurationClientConfiguration
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    dev: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    prod: null
});



// WEBPACK FOOTER //
// ./src/services/configuration/configurationHostName.js